export class ChartEntry {
  public patientNoteId: number | null = null;
  public appointmentId: number | null = null;
  public serviceId: number;
  public serviceTemplateId: number;
  public date: Date;
  public isLocked: boolean;

  public constructor(init?: Partial<ChartEntry>) {
    Object.assign(this, init);
  }
}
